export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_05.b4f8e874.jpg";